import React from "react";
import {
    Box,
    Divider,
    List,
    ListItem,
    ListItemText,
    Typography,
} from "@mui/material";
import BackButton from "../common/BackButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContentPageItem } from "../../api-data/service-provider/manage-contents";
import { slugify } from "../../api-data/util/baseDto";
import { useAuth } from "../../context/AuthContext";

interface MorePageProps {
    footerPages: ContentPageItem[];
}

const MorePage: React.FC<MorePageProps> = ({ footerPages }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isAuthenticated } = useAuth();

    return (
        <Box
            sx={{
                bgcolor: "background.paper",
                minHeight: "calc(100vh - 60px)",
                pb: "60px",
            }}
        >
            {/* Header */}
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="relative"
                px={3}
                py={2}
            >
                <Box sx={{ position: "absolute", left: 24 }}>
                    <BackButton />
                </Box>

                <Typography
                    variant="h6"
                    color="primary"
                    fontWeight={500}
                    sx={{ justifySelf: "center", textAlign: "center", paddingLeft: 3 }}
                >
                    {t("more.title")}
                </Typography>
            </Box>

            <Divider />

            {/* Menu Items */}
            <List sx={{ px: 2 }}>
                {/* Register as Pro – unauthenticated users only */}
                {!isAuthenticated && (
                    <>
                        <ListItem
                            disablePadding
                            sx={{ py: 1.5 }}
                            onClick={() => navigate("/service-provider/register")}
                        >
                            <ListItemText primary={t("sidebar.registerAsAPro")} />
                            <ChevronRightIcon color="action" />
                        </ListItem>
                        <Divider />
                    </>
                )}

                {/* Dynamic CMS pages */}
                {footerPages.map((page: ContentPageItem) => (
                    <Box key={page.id}>
                        <ListItem
                            disablePadding
                            sx={{ py: 1.5 }}
                            onClick={() => navigate(`/content/${slugify(page.category)}`)}
                        >
                            <ListItemText primary={page.localized?.category ?? page.category} />
                            <ChevronRightIcon color="action" />
                        </ListItem>
                        <Divider />
                    </Box>
                ))}

                {/* How it works */}
                <ListItem
                    disablePadding
                    sx={{ py: 1.5 }}
                    onClick={() => navigate("/how-it-works")}
                >
                    <ListItemText primary={t("header.navHowItWorks")} />
                    <ChevronRightIcon color="action" />
                </ListItem>
                <Divider />

                {/* App Information */}
                <ListItem
                    disablePadding
                    sx={{ py: 1.5 }}
                    onClick={() => navigate("/app-info")}
                >
                    <ListItemText primary={t("more.appInformation")} />
                    <ChevronRightIcon color="action" />
                </ListItem>
            </List>
        </Box>
    );
};

export default MorePage;
